import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useOutletContext } from "react-router";
import "./TopBar.scss";
import { Help } from "./components/Help";
import { UserMenu } from "./components/UserMenu";
import MyProfile from "./components/MyProfile";
import { setShowMyProfile } from "../authenticated-frame.local-state";
export default function TopBar() {
    var _a, _b;
    const { loadedState, localDispatch } = useOutletContext();
    function showMyProfile() {
        localDispatch(setShowMyProfile({ showMyProfile: true }));
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "topBar", children: [_jsx("div", { className: "leftWrap" }), _jsxs("div", { className: "rightWrap", children: [_jsx(Help, { isUnityPlatform: (_a = loadedState.org) === null || _a === void 0 ? void 0 : _a.is_platform_unity }), _jsx(UserMenu, { showUserProfile: () => showMyProfile(), user: loadedState.user, orgSwitcherAvailable: (_b = loadedState.features) === null || _b === void 0 ? void 0 : _b.show_org_switcher })] })] }), _jsx(MyProfile, {})] }));
}
